import { memo } from 'react'

import moment from 'moment'

import { Caption } from '@collaborate-health/uikit'

export interface ArticleDateProps {
  date: string
}

const ArticleDate: React.FC<ArticleDateProps> = ({ date }) => {
  return <Caption noWrap>Posted {moment(date).calendar()}</Caption>
}

export default memo(ArticleDate)

